import { TrendsResult } from "api/useAnalytics";
import { DATE_DESCRIPTIVE_FORMAT } from "constants/constants";
import dayjs from "dayjs";
import sortBy from "lodash.sortby";
import { EStatisticType } from "views/Statistics/StatisticsView.types";

import { ChartData } from "./analyticsChart.config";

export const getFormattedTrendsData = (currentTrends: TrendsResult['values'], previousTrends?: TrendsResult['values']): ChartData[] => {
    const currentTrendsSortedByDate = sortBy(currentTrends, 'date');
    const previousTrendsSortedByDate = previousTrends ? sortBy(previousTrends, 'date') : undefined;
    return currentTrendsSortedByDate.map((trend, index) => {
        const current = trend.value
        const previous = previousTrendsSortedByDate?.[index]?.value
        return {
            currentDate: trend.date,
            currentValue: getNumericValue(current) ?? 0,
            previousDate: previousTrendsSortedByDate?.[index]?.date,
            previousValue: getNumericValue(previous),
        }
    })
    
}

const getNumericValue = (value: string | number | undefined): number | undefined => {
    if (value === undefined || (typeof value === 'string' && value.length === 0)) {
        return undefined;
    }
    if (typeof value === 'string') {
        return parseFloat(value);
    }
    return Number(value);
}

export const getChartLabelFromDate = (date: string, xAxisDateFormat: string): string => {
    return dayjs(date).format(xAxisDateFormat);
}

export const getDescriptiveLabelFromDate = (date: string): string => {
    return dayjs(date).format(DATE_DESCRIPTIVE_FORMAT);
}

export const getFormattedValueByType = (value: number | string, type: EStatisticType) => {
    const numberValue = getNumericValue(value) ?? 0;
    const formattedValue = numberValue.toFixed(getDecimalPlaces(numberValue, type))
    if (type === EStatisticType.CURRENCY || type === EStatisticType.AMOUNT_AVERAGE) {
        return `$${formattedValue}`;
    }
    if (type === EStatisticType.PERCENTAGE) {
        return `${formattedValue}%`;
    }
        return `${formattedValue}`;
};

export const getDecimalPlaces = (
    value: number,
    type: EStatisticType,
  ) => {
    if (type === EStatisticType.NUMBER) {
      return 0;
    }
    
    return value % 1 !== 0 ? 2 : 0;
  };